import type { TMessages } from '@/types/TMessages'

export const messages = {
  notification: {
    title: 'Загрузите один из следующих наборов документов:',
  },
} satisfies TMessages
